(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypesService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypesService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesService
	 * 
	 * @description
	 * Exposes methods for retrieving content types that belong to a content
	 * type group.
	 */
	function ContentTypesService($http, $q, gettextCatalog, pxUriPathService) {
		
		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypesService.getContentTypes
			 * @methodOf smb-app.smbContentTypesService
			 * @kind function
			 * 
			 * @description
			 * Gets all content types the belong to a content type group
			 * 
			 * @param {Number} groupId Id of the content type group
			 * 
			 * @returns {Deferred} A promise that will resolve to a collection of content types
			 */
			getContentTypes: getContentTypes,
			deleteContentType: deleteContentType
		};

		function getContentTypes(groupId) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}

		function deleteContentType(typeId, purge) {
			if (!typeId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
			}

			purge = typeof(purge) === 'boolean' ? purge : false;
			var uri = pxUriPathService.resolvePath('/f/{id}?purge={purge}', {
				id: typeId,
				purge: purge
			});

			return $http.delete(uri);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentTypesService.js
// module id = 145
// module chunks = 1